export const initialValues = {
  "username": "",
  "password": "",
  "confirmPassword": "",
  "email": ""
}
  
export const fieldValidations = {
  "username": {
    "required": true
  },
  "password": {
    "required": true
  },
}
  